import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { makeStyles } from '@mui/styles';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const useStyles = makeStyles((theme) => ({
    snackbar: {
        zIndex: '1504 !important',
    }
}));

export default function DirectionSnackbarAlert({ snackbarDisplay, message, className, templateUpdater }) {
    const [open, setOpen] = React.useState(snackbarDisplay);
    const classes = useStyles();
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        if (templateUpdater !== null) {
            templateUpdater('idle');
        }
        setOpen(false);
    };

    let classNameStatus = 'warning';
    if (className === 'template-update-snackbar' || className === 'question-update-snackbar') {
        classNameStatus = 'success';
    }
    else if (className === 'question-update-error-snackbar') {
        classNameStatus = 'warning';
    }
    else if(className === 'reschedule-email-sent'){
        classNameStatus = 'success';
    }


    // console.log(message, open);
    return (
        <Stack spacing={2} sx={{ width: '80%' , zIndex:'1504'}}>
            <Snackbar open={open} onClose={handleClose} className={className}  classes={{ root: classes.snackbar }}>
                <Alert onClose={handleClose} severity={classNameStatus} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}
